import { h } from "@stencil/core";

export const InformationFlag = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'>
        <g id='Icon/Flag/Information' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
            <rect id='Rectangle-5' fill='#707070' x='4' y='8' width='40' height='32'></rect>
            <rect id='Rectangle' fill='#FFFFFF' x='22' y='21' width='4' height='14'></rect>
            <rect id='Rectangle-Copy' fill='#FFFFFF' x='18' y='34' width='12' height='2'></rect>
            <rect id='Rectangle-Copy-2' fill='#FFFFFF' x='18' y='20' width='8' height='2'></rect>
            <circle id='Oval' fill='#FFFFFF' cx='24' cy='14' r='2'></circle>
            <rect id='Rectangle-2' fill='#FFFFFF' x='22' y='12' width='4' height='4'></rect>
        </g>
    </svg>
);
